<div *ngIf="process.statsByStatus">
    <h3 *ngIf="!smallTitle && !hideTitle" class="md-subhead">Statistic by calculation statuses:</h3>
    <h4 *ngIf="smallTitle && !hideTitle" class="md-subhead">Statistic by calculation statuses:</h4>
    <div class="mat-typography content" style="position: relative; top: -10px">
        <div *ngIf="showTotal" class="flex" style="margin-bottom: 0px">
            <span class="w-70">Total property records:</span>
            <span class="w-15">{{ process.totalPropertyRecords}}</span>
            <span *ngIf="showRatio" class="w-15"></span>
        </div>

        <div class="flex" *ngFor="let status of process.statsByStatus">
            <span class="w-70">{{ statusFormatter(status.status) }}:</span>
            <span class="w-15">{{ status.count }}</span>
            <span *ngIf="showRatio" class="w-15">{{ status.ratio || getRatio(status.count, process.zoningCodeRecords)
                }}%</span>
        </div>

        <div class="flex">
            <span class="w-70" style="font-weight: 450;">Processed Property Records:</span>
            <span class="w-15" style="font-weight: 450;">{{ summaryStatistic({statsByStatus: process.statsByStatus,
                zoningCodeRecords: process.zoningCodeRecords}).count}}</span>
            <span *ngIf="showRatio" class="w-15" style="font-weight: 450;">{{ summaryStatistic({statsByStatus:
                process.statsByStatus,
                zoningCodeRecords:
                process.zoningCodeRecords}).ratio
                }}%</span>
        </div>

        <!-- <div *ngIf="process.allCalculatedPR" class="flex">
            <span class="w-70">Calculated Property Records:</span>
            <span class="w-15">{{ process.allCalculatedPR }}</span>
        </div> -->
    </div>
</div>